import { render, staticRenderFns } from "./temcenter5.vue?vue&type=template&id=c92a7b52&scoped=true"
import script from "./temcenter5.vue?vue&type=script&lang=js"
export * from "./temcenter5.vue?vue&type=script&lang=js"
import style0 from "./temcenter5.vue?vue&type=style&index=0&id=c92a7b52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92a7b52",
  null
  
)

export default component.exports